// extracted by mini-css-extract-plugin
module.exports = {"menu":"FloatingMenu_menu__j9NO6","hiddenMenu":"FloatingMenu_hiddenMenu___onh_ FloatingMenu_menu__j9NO6","visibleMenu":"FloatingMenu_visibleMenu__3rIN3 FloatingMenu_menu__j9NO6"};